// Vocabulário completo de `SwapStatus` (Higher-API, SwapEnums.cs) traduzido
// em português. Extraído do local que já era a fonte de verdade
// (`OperationHistory.jsx`) para cá porque `QuoteCard.jsx` também precisa
// dele: o defeito da Task 28 nasceu exatamente de tratar os status um a um
// em vez de contra este vocabulário inteiro, então duplicar o mapa em cada
// arquivo reintroduziria o mesmo risco de esquecer um valor quando o
// backend ganhar um status novo — um só lugar para editar pesa mais que
// evitar este import extra.
export const STATUS_LABEL = {
  Quoted: "Cotada",
  Locked: "Travada",
  LockUncertain: "Trava em dúvida",
  AwaitingDeposit: "Aguardando depósito",
  AwaitingSettlement: "Aguardando liquidação",
  Completed: "Concluída",
  Expired: "Vencida",
  Cancelled: "Cancelada",
};

export function statusLabel(status) {
  return STATUS_LABEL[status] || status;
}
